<template>
  <div class="mymap" :style="{'height':height + 'px'}">

    <g-map-map ref="mapRef" :center="center" :zoom="zoom" :map-type-id="mapType" class="chartmap"
              @zoom_changed="zoomChange" @center_changed="centerChange" :options="{fullscreenControl:false, streetViewControl: false}"/>

    <search-menu :map="map" v-if="showSearchbox" placeholder="Karte durchsuchen ..."/>

    <control-overlay :legendEnabled="showLegend" :kmlEnabled="showKML" :legendEntries="legendEntries" :map="map" :kmlFileDir="kmlFileDir"
                     :kmlTitle="kmlTitle" @show-kml-error="errorMessage = $event" :embedded="embedded"/>

    <side-query-overlay :queryID="queryID" :queryParams="queryParams" :embedded="embedded"/>

    <error-message-overlay :errorMessage="errorMessage"/>
  </div>
</template>

<script>
  import controlOverlay from '../../charts/ControlOverlay'
  import searchMenu from '../../charts/SearchMenu'
  import sideQueryOverlay from '../../charts/SideQueryOverlay'
  import errorMessageOverlay from '../../charts/ErrorMessageOverlay'
  import CSVHelper from '../../../classes/CSVHelper'
  export default {
    name: 'GoogleMapsKML',
    props: ['height', 'chartType', 'queryColumns', 'queryResult', 'setupToken','queryID', 'queryParams', 'queryMeta', 'embedded'],
    components: {controlOverlay, searchMenu, sideQueryOverlay, errorMessageOverlay},

    data() {
      return {
        center: { lat: 48.30639, lng: 14.28611 },
        zoom: 9,
        map: null,
        legendEntries: [],
        showLegend: false,
        showKML: false,
        kmlFileDir: null,
        kmlTitle: null,
        showSearchbox: false,
        zoomSetByStorage: false,
        centerSetByStorage: false,
        mapType: "roadmap",
        errorMessage: null
      }
    },

    watch: {
      queryResult() {
        this.legendEntries = []
        this.init()
      }
    },

    methods: {
      init() {
        this.errorMessage = null
        if(this.queryResult.length == 0){
          this.errorMessage = this.queryMeta.msgOnEmptyresult
        } else {
          try{
            //no query or webentity, only kml
          } catch (err){
            this.eventBus.globalErrorHandling("Fehler beim Erstellen der Karte", err)
            this.errorMessage = this.queryMeta.msgOnError
          }
        }
      },

      setupConfig(){
        let mySetupToken = CSVHelper.getObjectArrayFromCSV(this.setupToken)

        if(mySetupToken.mapType){
          this.mapType = mySetupToken.mapType
        }
        this.showLegend = mySetupToken.legendActive
        this.showKML = mySetupToken.layerSidebarActive
        this.kmlFileDir = mySetupToken.layerFiledir
        this.kmlTitle = mySetupToken.layerSidebarTitle
        this.showSearchbox = mySetupToken.searchboxActive
        if(!this.zoomSetByStorage){
          this.zoom = mySetupToken.zoomLevel
        }
        if(!this.centerSetByStorage){
          if(mySetupToken.latLng){
            let splitStr = mySetupToken.latLng.split(",")
            if(splitStr.length == 2){
              this.center = { lat: parseFloat(splitStr[0]), lng: parseFloat(splitStr[1])}
            }
          }
        }
      },

      zoomChange(zoom) {
        localStorage.setItem(this.queryID + "__zoomKMLBorder", JSON.stringify(zoom));
      },

      centerChange(center) {
        localStorage.setItem(this.queryID + "__centerKMLBorder", JSON.stringify(center));
      }
    },

    async mounted() {
      let lsCenter = localStorage.getItem(this.queryID + "__centerKMLBorder");
      let lsZoom = localStorage.getItem(this.queryID + "__zoomKMLBorder");
      if(lsCenter){
        this.center = safeParseJSON(lsCenter)
        this.centerSetByStorage = true
      }
      if(lsZoom){
        this.zoom = safeParseJSON(lsZoom)
        this.zoomSetByStorage = true
      }
      await this.$gmapApiPromiseLazy();
      this.setupConfig()
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map
        this.init()
      })
    }
  }

</script>

<style lang="sass">
.chartmap
  height: 100%
</style>
